import { render, staticRenderFns } from "./uploadingImg.vue?vue&type=template&id=5af7357e&scoped=true"
import script from "./uploadingImg.vue?vue&type=script&lang=js"
export * from "./uploadingImg.vue?vue&type=script&lang=js"
import style0 from "./uploadingImg.vue?vue&type=style&index=0&id=5af7357e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7357e",
  null
  
)

export default component.exports